<template>
  <v-app>
    <v-app-bar app color="primary">
      <v-app-bar-nav-icon
        class="white--text mr-2"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <h1 class="white--text">Splinti.de</h1>
      <v-spacer></v-spacer>
      <v-btn icon @click="openDiscord">
        <v-icon>fab fa-discord</v-icon>
      </v-btn>
      <v-btn icon @click="openTwitch">
        <v-icon>fab fa-twitch</v-icon>
      </v-btn>
      <v-btn icon @click="$vuetify.theme.dark = !$vuetify.theme.dark">
        <v-icon v-if="darkMode">fa fa-sun</v-icon>
        <v-icon v-else>fa fa-moon</v-icon>
      </v-btn>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" app>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="text-h6"> Splinti.de </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list dense nav>
        <template v-for="item in items">
          <v-list-item
            dense
            v-if="!item.children"
            :color="item.color"
            :key="item.title"
            link
            :to="item.to"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-group
            v-else-if="item.children"
            :color="item.color"
            :key="item.title"
            dense
            no-action
          >
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon v-if="!item.isSvg">{{ item.icon }}</v-icon>
                <img v-else :src="item.icon" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="child in item.children"
              :color="item.color"
              :key="child.title"
              link
              :to="child.to"
            >
              <v-list-item-icon>
                <v-icon v-if="!child.isSvg">{{ child.icon }}</v-icon>
                <img v-else :src="child.icon" />
              </v-list-item-icon>
              <v-list-item-title>{{ child.title }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-main class="mainApp">
      <modal-component>
        <v-container fluid>
          <router-view />
        </v-container>
      </modal-component>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import Vue from "vue";
import ModalComponent from "./plugins/modal/ModalComponent.vue";
import SocketIOProvider from "./socketIO/SocketIOProvider";

interface menuItem {
  title: string;
  icon: string;
  isSvg?: boolean;
  to?: string;
  children?: menuItem[];
  color: string;
}

export default Vue.extend({
  components: { ModalComponent },
  name: "App",
  data() {
    return {
      drawer: false,
      items: [
        {
          title: "Home",
          icon: "fa fa-home",
          to: "/",
          color: "primary",
        },
        {
          title: "Delta Force",
          icon: "/img/dflogo.svg",
          isSvg: true,
          color: "green accent-2",
          children: [
            {
              title: "Waffenbuilds",
              icon: "fa fa-gun",
              to: "/df/builds",
              color: "green accent-2",
            },
            {
              title: "Einstellungen",
              icon: "fa fa-cogs",
              to: "/df/settings",
              color: "green accent-2",
            },
          ],
        },
        {
          title: "Musik Queue",
          icon: "fa fa-music",
          to: "/music/queue",
        },
      ] as menuItem[],
    };
  },
  mounted() {
    const socketIoProv = SocketIOProvider;
    socketIoProv.connect();
  },
  methods: {
    openDiscord() {
      window.open("https://discord.gg/zmSRrd2", "_blank");
    },
    openTwitch() {
      window.open("https://www.twitch.tv/splinti", "_blank");
    },
  },
  computed: {
    darkMode(): boolean {
      return this.$vuetify.theme.dark;
    },
  },
});
</script>

<style lang="scss">
.mainApp {
  padding-bottom: 1rem;
  height: 100vh;
  overflow-y: auto;
}
</style>
